import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

export type GestionFeature = 'estado-tramite' | 'factura' | 'revocar';

interface GestionPlaceholderMeta {
  title: string;
  lead: string;
  difficulty: 'Baja' | 'Media' | 'Alta';
  difficultyNote: string;
  canalPath: string;
}

const META: Record<GestionFeature, GestionPlaceholderMeta> = {
  'estado-tramite': {
    title: 'Estado del trámite',
    lead: 'Consulta el avance de tu solicitud con tipo y número de documento.',
    difficulty: 'Baja',
    difficultyNote: 'Formulario simple + listado. Menos dependencias externas.',
    canalPath: '/estado-tramite'
  },
  factura: {
    title: 'Descargar factura',
    lead: 'Obtén el PDF de tu factura con los datos de la compra.',
    difficulty: 'Media',
    difficultyNote:
      'Validaciones de formulario + descarga PDF / reintentos. Al identificar al titular, mostrar saludo “Hola, {nombre}.” (mismo patrón que descarga y estado del trámite).',
    canalPath: '/descargar-factura'
  },
  revocar: {
    title: 'Revocar certificado',
    lead: 'Anula la vigencia de un certificado tras validar identidad.',
    difficulty: 'Alta',
    difficultyNote:
      'Validación de identidad, motivos, y doble factor RSE en Certifirma Digital Virtual. Tras identificar al titular, mostrar saludo “Hola, {nombre}.” (mismo patrón que descarga y estado del trámite).',
    canalPath: '/revocar-certificado'
  }
};

@Component({
  selector: 'app-gestion-placeholder',
  templateUrl: './gestion-placeholder.component.html',
  styleUrls: ['./gestion-placeholder.component.css'],
  standalone: false
})
export class GestionPlaceholderComponent implements OnInit {
  meta: GestionPlaceholderMeta = META['estado-tramite'];
  feature: GestionFeature = 'estado-tramite';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const feature = (this.route.snapshot.data['feature'] as GestionFeature) || 'estado-tramite';
    this.feature = feature;
    this.meta = META[feature] ?? META['estado-tramite'];
  }

  get difficultyClass(): string {
    switch (this.meta.difficulty) {
      case 'Baja':
        return 'is-low';
      case 'Media':
        return 'is-mid';
      default:
        return 'is-high';
    }
  }
}
